import apisauce from "apisauce";
import get from "lodash/get";
import hasIn from "lodash/hasIn";
import { logoutUser } from "../store/actions";
import { toast } from "react-toastify";
import { graphqlBaseUrl, restBaseUrl } from "../helpers";
import { store } from "../store/store";
import { sanitizeOtaMessage } from "../utils/otaUtils";

const SOMETHING_WENT_WRONG = "Something went wrong.";

toast.configure();

const logOutUser = async () => {
    store.dispatch(logoutUser());
};

const checkForErrors = (error) => {
    if (hasIn(error, "message.message")) {
        const statusCode = get(error, "message.statusCode", 400);
        if (statusCode === 401) {
            toast.error("Unauthorized");
            logOutUser();
        } else {
            toast.error(sanitizeOtaMessage(get(error, "message.message", SOMETHING_WENT_WRONG)));
        }
    } else if (hasIn(error, "message")) {
        if(window.location.pathname === "/login" && error.message === "Unauthorized"){
            return
        } else {
            toast.error(sanitizeOtaMessage(get(error, "message", SOMETHING_WENT_WRONG)));
        }
    } else if (typeof error === "string") {
        toast.error(sanitizeOtaMessage(error) ?? SOMETHING_WENT_WRONG);
    } else {
        toast.error(SOMETHING_WENT_WRONG);
    }
};

// eslint-disable-next-line consistent-return
const isAuthorized = (resp) => {
    if (resp.status === 401) return logOutUser();

    if (!resp.ok) return checkForErrors(get(resp, "data.errors[0]"));

    if (resp.ok && hasIn(resp, "data.errors")) {
        return checkForErrors(get(resp, "data.errors[0]"));
    }

    if (resp.ok && hasIn(resp, "data.error")) {
        return checkForErrors(get(resp, "data.error"));
    }
};

const customResponseStatus = (response) => {
    if (!response.ok) {
        response.data.customStatus = false;
    } else if (response?.data?.errors) {
        response.data.customStatus = false;
    } else {
        response.data.customStatus = true;
    }
};

export const apiConfig = () => {
    const api = apisauce.create({
        baseURL: graphqlBaseUrl,
        timeout: 120000,
    });

    api.addMonitor(isAuthorized);
    api.addResponseTransform(customResponseStatus);

    return api;
};

const isRestAuthorized = (resp) => {
    if (resp.status === 401) {
        logOutUser();
        return;
    }

    if (!resp.ok) checkForErrors(get(resp, "data.message", SOMETHING_WENT_WRONG));
};

const customRestResponseStatus = (response) => {
    // A gateway error yields an HTML string body, not an object - assigning onto it throws.
    if (!response.data || typeof response.data !== "object") return;

    response.data.customStatus = Boolean(response.ok && response.data.success !== false);
};

export const restApiConfig = () => {
    const api = apisauce.create({
        baseURL: restBaseUrl,
        timeout: 120000,
    });

    api.addMonitor(isRestAuthorized);
    api.addResponseTransform(customRestResponseStatus);

    return api;
};
